/**
 * Phaser.Group/Graphic class for the banner that gets shown in RequestHelp
 * @author Sandra Koo
 */
export class RequestHelp_Banner extends Phaser.Group {
  /**
   * config = {
   *  text: string,
   *  bannerImg: string
   * }
   * @param {Object} config
   */
  constructor(config) {
    super(G.Game, null);

    this.bannerText = {
      style: 'font-white',
      fontSize: 36,
      align: 'center',
      lineSpacing: -10,
    };

    this.bannerInfo = config;

    this.createBanner();
  }

  createBanner() {
    const bannerDisplay = new Phaser.Group(G.Game, this);
    const bannerImg = G.makeImage(0, 0, this.bannerInfo.bannerImg, 0.5, null);
    const bannerText = new G.Text(0, 0, this.bannerInfo.text, this.bannerText, 0.5, bannerImg.width, bannerImg.height, true, 'center');
    bannerText.y = 2 + bannerImg.y - bannerText.height / 4;
    bannerDisplay.addChild(bannerImg);
    bannerDisplay.addChild(bannerText);

    return bannerDisplay;
  }
}
